import cx from 'classnames';
import { useContext } from 'react';
import { MediaContext } from 'components/mediaQuery';
import Link from 'next/link';

import styles from './footer.module.css';

const Footer = () => {
  const { mobile } = useContext(MediaContext);

  return (
    <footer className={cx(styles.footer, 'py-8')}>
      <div className={cx(styles.inner, 'px-6')}>
        <div className={styles.logoBlock}>
          <Link href="/">
            <a className={cx(styles.logo, 'hover:underline')}>
              Poolup
            </a>
          </Link>
          <a className={styles.trustpilot} href="https://uk.trustpilot.com/review/poolup.bet" target="_blank" rel="noopener">
            Trustpilot
          </a>
        </div>
        <div className={cx(styles.linkBlock)}>
          <Link href="/terms">
            <a className={styles.link}>
              Terms & Conditions
            </a>
          </Link>
          <Link href="/faq">
            <a className={styles.link}>
              FAQ
            </a>
          </Link>
          <Link href="/contact">
            <a className={styles.link}>
              Contact us
            </a>
          </Link>
          {!mobile && (
            <span className={cx(styles.copy, 'w-full text-center')}>
              © Copyright Buzovska Chernysh 2022. All Rights Reserved.
            </span>
          )}
        </div>
        {mobile && (
          <span className={cx(styles.copy, 'w-full text-center')}>
            © Copyright Buzovska Chernysh 2022. All Rights Reserved.
          </span>
        )}
      </div>
    </footer>
  );
};

export default Footer;
